/*************************************************/
/* VIDEO                                         */
/*************************************************/
import customEventsNames from './../customEventsNames';
export function video() {
    const videoPlayerSelector = '.video-item__player';
    const modalVideoPlayerId = '#videoModal';
    const videoPlayerPlayingClass = 'video-item__player--playing';

    const init = function () {
        const playYoutubeVideo = (playerId, videoId) => {
            var iterations = 0;
            var loadViewTimer = setInterval(() => {
                if (youtubeLoaded) {
                    clearInterval(loadViewTimer);
                    let ytplayer = new YT.Player(playerId, {
                        height: '100%',
                        width: '100%',
                        videoId: videoId,
                        host: 'https://www.youtube-nocookie.com',
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        },
                        playerVars: {
                            showinfo: 0,
                            rel: 0
                        }
                    });
                } else {
                    iterations++;
                }

                //Lets try for 10 seconds
                if (iterations === 100) {
                    clearInterval(loadViewTimer);
                }

            }, 50);
        }

        const playVideo = (playerId) => {
            const player = document.getElementById(playerId);
            if (player.tagName == 'VIDEO') {
                player.play();

            } else {
                player.querySelector('video').play();
            }

            const videoPlayerElement = player.closest(videoPlayerSelector);
            if (videoPlayerElement) {
                videoPlayerElement.classList.add(videoPlayerPlayingClass);
            }
            const videoStartedPlayingInModalEvent = new Event(customEventsNames.videoPlayingInModal);
            document.querySelector(modalVideoPlayerId).dispatchEvent(videoStartedPlayingInModalEvent);
        }

        const onPlayerReady = event => {
            event.target.playVideo();
            const player = document.querySelector(`#player${event.target.playerInfo.videoData.video_id}`);

            const videoStartedPlayingInModalEvent = new Event(customEventsNames.videoPlayingInModal);
            document.querySelector(modalVideoPlayerId).dispatchEvent(videoStartedPlayingInModalEvent);

            const videoPlayerElement = player.closest(videoPlayerSelector);
            if (videoPlayerElement) {
                videoPlayerElement.classList.add(videoPlayerPlayingClass);

                if (videoPlayerElement.dataset.autoplay == 'true') {
                    event.target.mute();
                }
            }
        }

        const onPlayerStateChange = event => {
            if (event.data === YT.PlayerState.ENDED) {
                const player = document.querySelector(`#player${event.target.playerInfo.videoData.video_id}`);
                const videoPlayerElement = player.closest(videoPlayerSelector);
                if (videoPlayerElement) {
                    videoPlayerElement.classList.remove(videoPlayerPlayingClass);
                }
            }
        }

        document.addEventListener(customEventsNames.playVideoInModal, e => {
            if (e.target.id === 'modalplayer') {
                playVideo(e.detail.playerId);
            }
        });
        document.addEventListener(customEventsNames.playYoutubeVideoInModal, e => {
            if (e.target.id === 'modalplayer') {
                playYoutubeVideo(e.detail.playerId, e.detail.videoId);
            }
        }, false);

        document.addEventListener(customEventsNames.closeModal, e => {
            if (e.target.id === modalVideoPlayerId) {
                document.querySelector(videoPlayerSelector).classList.remove(videoPlayerPlayingClass);
            }
        }, false);

        const videoPlayerActionHandler = (e) => {
            const videoItem = e.target.closest(videoPlayerSelector);
            if (videoItem) {
                e.preventDefault();

                let videoId = videoItem.dataset.videoId;
                const playerId = videoItem.dataset.playerId;

                let videoSources = videoItem.dataset.videosources;
                let videoTypes = videoItem.dataset.videotypes;
                let autoplay = videoItem.dataset.autoplay == 'true';

                if (videoSources && videoTypes) {
                    videoSources = videoSources.split(',');
                    videoTypes = videoTypes.split(',');

                    const modalId = videoItem.dataset.target;
                    const videoElement = document.createElement('video');
                    videoElement.controls = true;

                    if (autoplay) {
                        videoElement.autoplay = true;
                        videoElement.loop = true;
                        videoElement.controls = false;
                        videoElement.muted = true;
                        videoElement.playsInline = true;
                    }

                    for (let i = 0; i < videoSources.length; i++) {
                        const sourceElement = document.createElement('source');
                        sourceElement.setAttribute('src', videoSources[i]);
                        sourceElement.setAttribute('type', videoTypes[i]);
                        videoElement.appendChild(sourceElement)
                    }

                    if (typeof modalId !== 'undefined' && modalId !== '') {
                        var openModalEvent = new CustomEvent(customEventsNames.openModal, {
                            detail: {
                                modalId: modalId,
                                videoElement: videoElement
                            }
                        });

                        document.querySelector(modalVideoPlayerId).dispatchEvent(openModalEvent);

                    } else {

                        document.getElementById(playerId).replaceChildren(videoElement);
                        playVideo(playerId);
                    }
                }
                else if (typeof videoId != undefined && videoId != null && videoId != '') {
                    const consentData = [...window.dataLayer].reverse().find(item => item.event === "consent_status");

                    if (!consentData || !consentData.ucCategory || typeof consentData.ucCategory.marketing !== "boolean" || !consentData.ucCategory.marketing) {
                        window.RenewConsent();
                    } else {
                        console.warn('Remember to setup the cookie consent solution for the Youtube script in video.js');
                        const tag = document.createElement('script');
                        tag.src = 'https://www.youtube.com/iframe_api';
                        const firstScriptTag = document.getElementsByTagName('script')[0];
                        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);


                        //If video id is not set, it's probably a link from a RTE
                        if (typeof videoId === undefined) {
                            videoId = videoItem.querySelector('a').getAttribute('href');
                            if (videoId && videoId.indexOf('/') === 0 && videoId.length > 1) {
                                videoId = videoId.substr(1);
                            }
                        }
                        if (videoId) {
                            const modalId = videoItem.dataset.target;
                            if (typeof modalId !== 'undefined' && modalId !== '') {
                                var openModalEvent = new CustomEvent(customEventsNames.openModal, {
                                    detail: {
                                        modalId: modalId,
                                        videoId: videoId
                                    }
                                });

                                document.querySelector(modalVideoPlayerId).dispatchEvent(openModalEvent);

                            } else {
                                playYoutubeVideo(playerId, videoId);
                            }
                        } else {
                            console.error('Video not found');
                        }
                    }
                }
            }
        }

        const videoPlayers = document.querySelectorAll(videoPlayerSelector);
        if (videoPlayers.length > 0) {
            videoPlayers.forEach(player => {

                player.addEventListener('click', e => {
                    //Only play the video if it's not already playing
                    const videoPlayer = player.querySelector('video');
                    if (!videoPlayer) {
                        videoPlayerActionHandler(e);
                    }
                });

                player.addEventListener('keyup', e => {
                    e.preventDefault();
                    if (e.key === 'Enter') {
                        videoPlayerActionHandler(e);
                    }
                });
            })
        }

    };

    init();
}
